module.exports = __webpack_public_path__ + "assets/mikeBoxIcon1.d02b25a4.svg";